/* eslint-disable */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Toolbar from '../../../../../../../components/common/Toolbar';
import BottomToolbar from '../../../../../../../components/common/BottomToolbar';
import List from '../../../../../../../components/common/List';
import BackButton from '../../../../../../../components/common/BackButton';
import Form from '../../../../../../../components/common/Form.js';
import merge from 'lodash/merge';
import { isLandingPage } from '../../../../../../../utils/common';
import { stringifyFacets } from '../../../../../../../utils/products.js';
import commify from '../../../../../../../modules/ajio-util/commify.js';
import { showModal, hideModal } from '../../../../../../../actions/modal.js';
import { fetchProducts } from '../../../../../../../actions/shared/productsData.js';
import { removeFacets } from '../../../../../../../actions/shared/facets';
import Modal from '../../../../../../../components/common/Modal';
import { readCookie, getCookie } from '../../../../../../../components/common/Cookie';
import hexCode from '../../../../../../../modules/ajio-util/hexCode.js';
import Icon from '../../../../../../atoms/Icon';
import Input from '../../../../../../molecules/Input';
import AddressBarWrapper from '../../../../../../organism/AddressBarWrapper';
import { getLuxeFlags } from '../../../../../../../Flags/selectors';
import properties from '../../../../../../../modules/ajio-util/properties';
import { FLEEK_STORE } from '../../../../../../../constants/constant';
import { deliveryMethod as DELIVERY_METHOD } from '../../../../../../constants/ordersData.constants';
import {
  getPriorityDeliveryConfig,
  getPriorityDeliveryPhase2Flag,
  getPriorityDeliverySLPTagsConfig,
  getRushDeliveryFlag,
  getPlpOnLandingEnabled,
  getFilterTabsOnLandingEnabled
} from '../../../../../../selectors/featureFlagsSelector';
import { getPlpOnLandingData } from '../../../../../../selectors/plpOnLandingSelector';
import { replaceWithJioCDN } from '../../../../../../../utils/imageHandling';

class FacetCheckboxModalContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      floatLabelMin: false,
      floatLabelMax: false,
      displayDeliveryFilters: false,
      isSROnly: false
    };
  }

  getFormDefaultValues() {
    const { facetsQuery, entities = {} } = this.props;
    const defaultValues = merge({}, facetsQuery);

    Object.keys(entities).forEach(id => {
      const entity = entities[id] || {};
      const { childrens, code: facetCode } = entity;
      if (!childrens || !childrens.length || !facetCode) return;

      const currentValues = new Set(defaultValues[facetCode] || []);
      const apiSelectedCodes = [];

      childrens.forEach(childId => {
        const child = entities[childId] || {};
        if (child.selected && child.code && !currentValues.has(child.code)) {
          apiSelectedCodes.push(child.code);
        }
      });

      if (apiSelectedCodes.length) {
        defaultValues[facetCode] = [...currentValues, ...apiSelectedCodes];
      }
    });

    return defaultValues;
  }

  syncApiSelectedFacets() {
    const {
      entities = {},
      parentEntityId,
      facetsQuery = {},
      rightPaneFormValues,
      setRightPaneFormValues
    } = this.props;
    const parentEntity = entities[parentEntityId] || {};
    const { code } = parentEntity;
    if (!code) return;

    const hasApiSelected = Object.keys(entities).some(id => {
      const entity = entities[id] || {};
      if (!entity.childrens || !entity.code) return false;
      const queryValues = facetsQuery[entity.code] || [];
      return entity.childrens.some(childId => {
        const child = entities[childId] || {};
        return child.selected && child.code && !queryValues.includes(child.code);
      });
    });

    if (!hasApiSelected) return;

    // callers mutate the returned object — do not cache across calls
    const enriched = this.getFormDefaultValues();
    const base = rightPaneFormValues || merge({}, facetsQuery);
    const merged = { ...base };
    Object.keys(enriched).forEach(key => {
      if (Array.isArray(enriched[key])) {
        const baseArr = merged[key] || [];
        merged[key] = [...new Set([...baseArr, ...enriched[key]])];
      }
    });

    setRightPaneFormValues(code, merged);
  }

  groupEntityIdsByAlphabetic(facetEntityIds = [], selectedEntityIds = []) {
    const { entities = {} } = this.props;
    const groupedItems = facetEntityIds.reduce(
      (acc, entityId) => {
        const entity = entities[entityId];
        const { code, count, name = '' } = entity;
        let charAtIndex0 = name.charAt(0);
        const isAlpha = charAtIndex0 && charAtIndex0.length === 1 && charAtIndex0.match(/[a-z]/i);
        charAtIndex0 = isAlpha ? charAtIndex0 : '#';
        if (acc.entities[charAtIndex0]) {
          acc.entities[charAtIndex0].push(entityId);
        } else {
          acc.entities[charAtIndex0] = [{ title: charAtIndex0 }, entityId];
          acc.results.push(charAtIndex0);
        }
        return acc;
      },
      { entities: {}, results: [] }
    );

    return groupedItems.results.reduce((acc, alp) => {
      if (groupedItems.entities[alp]) {
        acc = acc.concat(groupedItems.entities[alp]);
      }
      return acc;
    }, []);
  }

  getAllSelectedFacetEntityIds(facetEntityIds = [], formSelectedValues = {}, facetCode) {
    const facetSelectedValues = formSelectedValues[facetCode] || [];
    const { entities = {} } = this.props;
    return facetEntityIds.filter(entityId => {
      const entity = entities[entityId];
      const { code } = entity;
      return facetSelectedValues.includes(code);
    });
  }

  getAllPopularEntityIds(facetEntityIds = [], selectedEntityIds = []) {
    const { entities = {} } = this.props;
    return [...facetEntityIds]
      .sort((entityIdA, entityIdB) => {
        const entityA = entities[entityIdA] || {};
        const entityB = entities[entityIdB] || {};
        if (entityA.count > entityB.count) {
          return -1;
        } else if (entityA.count < entityB.count) {
          return 1;
        }
        return 0;
      })
      .slice(0, 5);
  }

  formatChildrens(childrens = [], formSelectedValues = [], entities = {}, facetCode, searchTerm) {
    const {
      config = {},
      isFilterImprovementEnabled = false,
      filterImprovementConfig = {}
    } = this.props;

    // NOTE: FOR FILTER IMPROVEMENT (BRAND)
    const isFilterImprovementEnabledForBrand = isFilterImprovementEnabled && facetCode === 'brand';
    const getFilterNameFromConfig = () => {
      const { suggestedTitle = '' } = filterImprovementConfig?.[facetCode] || {};

      return suggestedTitle;
    };

    const getSuggestedValues = () => {
      const { suggestedValues = [] } = entities?.[facetCode] || {};

      return suggestedValues;
    };

    const facetSelectedValues = formSelectedValues[facetCode] || [];
    let selectedEntityIds = [];
    selectedEntityIds = this.getAllSelectedFacetEntityIds(childrens, formSelectedValues, facetCode);
    let selectedItemsTitle = [];
    if (config.showSelectedTopValues && selectedEntityIds.length) {
      selectedItemsTitle.push({ title: 'SELECTED' });
    }
    let popularEntityIds = [];
    let popularSectionTitle = [];
    if (config.showPopular && !searchTerm && childrens.length > 5) {
      popularEntityIds = isFilterImprovementEnabledForBrand
        ? getSuggestedValues()
        : this.getAllPopularEntityIds(childrens, selectedEntityIds);
      if (popularEntityIds && popularEntityIds.length > 0) {
        popularSectionTitle.push({
          title: isFilterImprovementEnabledForBrand ? getFilterNameFromConfig() : 'POPULAR'
        });
      }
    }
    let fullEntityIds = childrens;
    if (config.groupByAlphabets) {
      fullEntityIds = this.groupEntityIdsByAlphabetic(childrens, selectedEntityIds);
    }
    return [
      ...selectedItemsTitle,
      ...selectedEntityIds,
      ...popularSectionTitle,
      ...popularEntityIds,
      ...fullEntityIds
    ];
  }

  updateClass = () => {
    this.setState({
      floatLabelMin: true
    });
  };
  removeClass = () => {
    this.setState({
      floatLabelMin: false
    });
  };

  updateMaxClass = () => {
    this.setState({
      floatLabelMax: true
    });
  };
  removeMaxClass = () => {
    this.setState({
      floatLabelMax: false
    });
  };

  getPriceRangeGA = (priceRange, isChecked, code) => () => {
    !isChecked &&
      code === 'pricerange' &&
      window.ga &&
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Filter',
        eventAction: 'Filter Price Range',
        eventLabel: `${priceRange}`
      });
  };

  componentDidMount() {
    const userCurrentAddress = readCookie('USER_ADDR');
    const userCurrentAddressObj = (userCurrentAddress && JSON.parse(userCurrentAddress)) || {};
    const { pincode = '' } = userCurrentAddressObj;
    this.setState({ displayDeliveryFilters: pincode ? true : false });
    this.syncApiSelectedFacets();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isFloatOrFocusChanged !== this.props.isFloatOrFocusChanged) {
      console.log(
        '🚀 ~ isFloatOrFocusChanged updated ~ FacetCheckboxModalContent component re-rendering'
      );
    }
  }

  removeSlaFilterFromQuery = selectedFilters => {
    return selectedFilters.replace(/:sla:[^:]+/g, '').replace(/^sla:[^:]+:?/, '');
  };

  handleDisplayDeliveryFilters = (flag = false) => {
    if (flag) {
      const {
        request = {},
        clickedFilterTabCode = '',
        isPlpOnLandingEnabled = false,
        isFilterTabsOnLandingEnabled = false,
        plpOnLandingCuratedId = ''
      } = this.props;
      const { location = {} } = window;

      let pathname = `${request.pathname}`;
      const isFilterTabClickedOnLanding =
        isFilterTabsOnLandingEnabled && clickedFilterTabCode && isLandingPage();
      if (isPlpOnLandingEnabled && plpOnLandingCuratedId && isFilterTabClickedOnLanding) {
        pathname = `/api/curated/${plpOnLandingCuratedId}`;
      }
      const updatedRequest = {
        ...request,
        currentPage: 0,
        pathname,
        query: {
          ...request.query,
          query: this.removeSlaFilterFromQuery(request?.query?.query || ''),
          facets: this.removeSlaFilterFromQuery(request?.query?.facets || '')
        }
      };
      this.props.fetchFecetsFromPincode({
        request: JSON.parse(JSON.stringify(updatedRequest)),
        isRequestFromPlpOnLanding: isPlpOnLandingEnabled && isFilterTabClickedOnLanding
      });
    }
    this.setState({ displayDeliveryFilters: flag });
  };

  clearSLAFacetSelection = () => {
    let defaultValues = this.getFormDefaultValues();
    const values = this.props.rightPaneFormValues || defaultValues;
    values.sla = [];
    this.props.setRightPaneFormValues('sla', values);
  };

  render() {
    const {
      entities = {},
      pushToHistory,
      facetsQuery = {},
      location = {},
      history,
      fetchNextFacets,
      parentEntityId,
      rightPaneFormValues,
      config = {},
      priceFacets = {},
      selectedFacets,
      currentStore,
      luxeFlags,
      oldFlow,
      addressBook = {},
      isPriorityDeliveryOffered,
      priorityDeliveryConfig = {},
      priorityDeliverySLPTagsConfig = {},
      enablePriorityDeliveryPhase2 = false,
      enableRushDelivery = false,
      clickedFilterTabCode = '',
      plpOnLandingCuratedId = '',
      isPlpOnLandingEnabled = false,
      popupFilterFromBottom = false,
      isFilterTabsOnLandingEnabled = false,
      isFilterImprovementEnabled = false,
      isFilterImprovementPhase2Enabled = false,
      filterImprovementConfig = {},
      isLimitedScrollLandingPage = false,
      isFromPopup = false
    } = this.props;
    const imageBaseUrl = properties.getProperty('imageBaseUrl');
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && currentStore === 'luxe';
    const isFleek = currentStore === FLEEK_STORE;
    const { hash = '' } = location;
    const hasPriceFacet = facetsQuery.price ? true : false;
    // const parentEntityId = hash.replace("#filterBy-", "");
    const parentEntity =
      parentEntityId === 'pricerange' && Object.keys(priceFacets).length
        ? priceFacets?.entities?.[parentEntityId] || {}
        : entities[parentEntityId] || {};
    const { name = '', childrens = [], code } = parentEntity;

    const luxeColorFilter = luxe && code === 'verticalcolorfamily';
    const rushAvail = readCookie('RushAvail');
    const { rushDelivery: isRushDeliveryAvailable = false } =
      (rushAvail && JSON.parse(rushAvail)) || {};
    const {
      floatLabelMin = false,
      floatLabelMax = false,
      displayDeliveryFilters = false
    } = this.state;

    const style = {
      fontSize: '1.8rem',
      color: isFleek ? '#FFF' : '#254153',
      fontWeight: 'bold',
      position: 'absolute',
      top: '10px',
      right: '10px',
      opacity: '.7'
    };

    const luxeStyle = {
      fontSize: '24px',
      position: 'absolute',
      top: '6px',
      left: '16px'
    };

    const ratingItemContainer = {
      display: 'flex',
      height: '15px',
      alignItems: 'center',
      gap: '4px',
      fontSize: '12px',
      color: isFleek ? '#fff' : '#202020'
    };

    const starIconOnFilterStyle = {
      width: '15px'
    };

    const formDefaultValues = this.getFormDefaultValues();

    const returnNewDiv = ({ currentString }) => {
      const splitedArray = currentString.split('star');
      const imageBaseRef = properties.getProperty('imageBaseUrl') + '/static/img/';
      return (
        <span style={ratingItemContainer}>
          <p>{splitedArray[0]}</p>
          <img
            style={starIconOnFilterStyle}
            src={imageBaseRef + 'filled_star_rating.svg'}
            alt="Star"
          />
          <p>{splitedArray[1]}</p>
        </span>
      );
    };

    return (
      <div>
        <Form
          defaultValues={formDefaultValues}
          getFormValues={() => {
            const defaultValues = formDefaultValues;
            return rightPaneFormValues || defaultValues;
          }}
          setFormValues={formValues => {
            this.props.setRightPaneFormValues(code, formValues);
            if (code === 'brand') {
              this.setState({ isSROnly: true });
              setTimeout(() => {
                this.setState({ isSROnly: false });
              }, 1000);
            }
          }}
          onSubmit={() => {}}
        >
          {({ getFormDefaultProps, getFormValue, isTouched, addFormValue, formValues }) => {
            let formValue = getFormValue(code);
            let priceRange = getFormValue('price') || [];
            let priceRangeSplits = priceRange[0] ? priceRange[0].split(',') : [];
            let searchTerm = getFormValue('searchTerm');
            let filteredChildrens = filterChildrenByName(searchTerm, childrens, entities);
            filteredChildrens = this.formatChildrens(
              filteredChildrens,
              formDefaultValues,
              entities,
              code,
              searchTerm
            );
            if (parentEntityId !== 'brand') {
              filteredChildrens = siftFilterlist(filteredChildrens);
            }
            let searchComponent = null;
            const isPDPhase2AndDeliveryFilterSelected =
              (enableRushDelivery || enablePriorityDeliveryPhase2) && code === 'sla';
            if (config.showSearch) {
              searchComponent = (
                <div
                  className={`${luxe ? 'luxe-search-term-container-checkbox' : 'search-term-container'}`}
                  style={isFleek ? { background: '#1B1F23' } : {}}
                >
                  <input
                    {...getFormDefaultProps({
                      type: 'text',
                      name: 'searchTerm'
                    })}
                    value={Array.isArray(searchTerm) ? '' : searchTerm}
                    className={luxe ? 'luxe-search-term' : 'search-term'}
                    id={'search-term'}
                    placeholder={config.showSearch ? config.searchInputPlaceHolder : ''}
                    autoComplete="off"
                    style={isFleek ? { background: '#1B1F23', color: '#FFF' } : {}}
                  />
                  {luxe ? (
                    <Icon ariaLabel="Luxe search" icon="luxe-Search" styles={luxeStyle} />
                  ) : (
                    <Icon ariaLabel="Search" icon="icon-Search" styles={style} />
                  )}
                </div>
              );
            }
            let listDistribution = [];
            filteredChildrens.forEach(item => {
              if (typeof item === 'object' && item.title) {
                listDistribution.push([item]);
              } else {
                const lastGroup = listDistribution[listDistribution.length - 1];
                if (lastGroup) {
                  lastGroup.push(item);
                } else {
                  listDistribution.push([item]);
                }
              }
            });

            // NOTE: FOR FILTER IMPROVEMENT (GENDER)
            const isFilterImprovementEnabledAndIsGenderFilter =
              isFilterImprovementEnabled && parentEntityId === 'genderfilter';
            const { gender: { genderFilterApparels = [] } = {} } = filterImprovementConfig || {};
            const configuredGenders = [];
            const otherGenders = [];

            if (isFilterImprovementEnabledAndIsGenderFilter) {
              filteredChildrens.forEach(el => {
                const gender = el.split('-')?.[1] || '';

                if (genderFilterApparels.includes(gender)) {
                  return configuredGenders.push(el);
                }

                otherGenders.push(el);
              });
            }

            const getFilterImprovedmentGenderFilter = (eItem, iKey) => {
              const isBrandList = code === 'brand';
              const noMarginClass =
                isBrandList && iKey + 1 !== eItem.length ? 'rilrtl-list-no-margin' : '';

              return (
                <div role={isBrandList ? 'list' : undefined}>
                  <List
                    ignoreListBehavior={isBrandList}
                    numOfItems={eItem.length}
                    showSearch={config.showSearch}
                    luxe={luxe}
                    className={isFleek ? `fleek-category-modal ${noMarginClass}` : noMarginClass}
                    listItemRenderer={listProps => {
                      const { index } = listProps;
                      const entityId = eItem[index];
                      if (typeof entityId === 'object') {
                        return (
                          <div className={luxe && 'facet-brand-title'}>
                            <div
                              className={`facet-linkname ${
                                luxe ? 'facet-directory-luxe-title' : 'facet-directory-title'
                              }`}
                              style={isFleek ? { color: '#FFF' } : {}}
                              role="heading"
                              aria-level={2}
                            >
                              <strong>{entityId.title}</strong>
                            </div>
                          </div>
                        );
                      }
                      const entity = entities[`${entityId}`] || {};
                      let isChecked = false;
                      if (formValue) {
                        isChecked = formValue.includes(entity.code);
                      }
                      return (
                        <div role={isBrandList ? 'listitem' : undefined}>
                          <label
                            className="facet-linkname"
                            htmlFor={entity.name}
                            style={code === 'verticalcolorfamily' ? { marginBottom: '12px' } : {}}
                          >
                            <div>
                              <span
                                className="rilrtl-list-item__end-detail"
                                role="checkbox"
                                aria-checked={isChecked}
                                aria-labelledby={`facet-list-title-name-${(entity.name || '')
                                  .trim()
                                  .replace(/\s+/g, '')} facet-list-title-count-${commify(
                                  entity.count || ''
                                )}`}
                              >
                                <input
                                  {...(!popupFilterFromBottom && { tabIndex: '-1' })}
                                  style={!popupFilterFromBottom ? { display: 'none' } : undefined}
                                  {...getFormDefaultProps({
                                    type: 'checkbox',
                                    name: code,
                                    value: entity.code
                                  })}
                                  id={entity.name}
                                  checked={isChecked}
                                  onClick={this.getPriceRangeGA(entity.code, isChecked, code)}
                                />
                                {luxe ? (
                                  <Icon
                                    ariaHidden={true}
                                    icon={`${
                                      isChecked ? 'luxe-Checkbox-Selected' : 'luxe-Checkbox'
                                    }`}
                                    styles={
                                      isChecked
                                        ? { fontSize: '2.2rem', color: '#121212' }
                                        : { fontSize: '2.2rem', opacity: 0.5 }
                                    }
                                  />
                                ) : (
                                  <Icon
                                    ariaHidden={true}
                                    icon={`${
                                      isChecked ? 'icon-Checkbox-Selected' : 'icon-Check-box'
                                    }`}
                                    styles={
                                      isFleek
                                        ? { color: '#EBFF00', fontSize: '2.2rem' }
                                        : { fontSize: '2.2rem' }
                                    }
                                  />
                                )}
                              </span>
                            </div>

                            <span
                              aria-hidden="true"
                              className={`${
                                luxe ? 'rilrtl-list-luxe-item__title' : 'rilrtl-list-item__title'
                              } ${isChecked ? 'list-active' : ''} ${
                                parentEntityId === 'verticalcolorfamily'
                                  ? 'filter-improvement-color__icon'
                                  : ''
                              }`}
                              style={isFleek ? { paddingLeft: '8px' } : {}}
                            >
                              {parentEntityId === 'verticalcolorfamily' && (
                                <i
                                  className={`${
                                    luxe ? 'facet-luxe-color' : 'facet-color'
                                  } facet-color-${entity.name}`}
                                  style={{
                                    backgroundColor: hexCode(entity.name.toLowerCase()) || name,
                                    ...(isFleek
                                      ? { border: '1px solid #F0F4F7', marginRight: '10px' }
                                      : {}),
                                    ...(entity.name === 'Multi'
                                      ? {
                                          background: `url(${`${imageBaseUrl}/static/img/multi_color_swatch.png`})`,
                                          backgroundRepeat: 'no-repeat',
                                          backgroundPosition: 'center'
                                        }
                                      : {})
                                  }}
                                />
                              )}
                              <span
                                id={`facet-list-title-name-${(entity.name || '')
                                  .trim()
                                  .replace(/\s+/g, '')}`}
                                className={
                                  luxeColorFilter
                                    ? 'facet-list-color-title-name'
                                    : `facet-list-title-name ${
                                        isFleek ? 'fleek-color-important' : ''
                                      }`
                                }
                                style={
                                  isPDPhase2AndDeliveryFilterSelected &&
                                  (!isPriorityDeliveryOffered || entity.count === 0)
                                    ? { opacity: 0.5 }
                                    : {}
                                }
                                aria-label={entity.name
                                  .replace(/Rs\.?/g, 'Rupees')
                                  .replace(/(\d+)\s*-\s*(\d+)/, '$1 to $2')}
                              >
                                {`${entity.name}`}{' '}
                              </span>
                              {!(
                                isPDPhase2AndDeliveryFilterSelected &&
                                (!isPriorityDeliveryOffered ||
                                  entity.count === 0 ||
                                  enableRushDelivery)
                              ) && (
                                <span
                                  id={`facet-list-title-count-${commify(entity.count || '')}`}
                                  className={`facet-list-title-count ${
                                    isFleek ? 'fleek-color-important' : ''
                                  }`}
                                  aria-label={`(${commify(entity.count || '')}) ${
                                    entity.count ? 'items' : ''
                                  } `}
                                >
                                  {' '}
                                  {`(${commify(entity.count || '')})`}
                                </span>
                              )}
                            </span>
                          </label>
                        </div>
                      );
                    }}
                    isFleek={isFleek}
                    oldFlow={oldFlow}
                    keepDefaultRole
                  />
                </div>
              );
            };

            const renderFilterImprovementGender = () => {
              const { gender: { primaryHeader = '', secondaryHeader = '' } = {} } =
                filterImprovementConfig || {};

              return (
                <div className="gender_container">
                  {configuredGenders?.length > 0 && (
                    <div className="gender_item">
                      <p className={`${luxe ? 'luxe' : ''} ${isFleek ? 'ajiogram' : ''}`}>
                        {primaryHeader}
                      </p>
                      <div>
                        {configuredGenders.map((eItem, iKey) =>
                          getFilterImprovedmentGenderFilter([eItem], iKey)
                        )}
                      </div>
                    </div>
                  )}
                  {otherGenders.length > 0 && (
                    <div className="gender_item">
                      <p className={`${luxe ? 'luxe' : ''} ${isFleek ? 'ajiogram' : ''}`}>
                        {secondaryHeader}
                      </p>
                      <div>
                        {otherGenders.map((eItem, iKey) =>
                          getFilterImprovedmentGenderFilter([eItem], iKey)
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            };

            // NOTE: FOR FILTER IMPROVEMENT (COLORS)
            const isFilterImprovementEnabledAndIsColorFilter =
              isFilterImprovementPhase2Enabled && parentEntityId === 'verticalcolorfamily';
            const renderFilterImprovementColor = () => {
              const { colorGroups = [] } = parentEntity || {};

              return (
                <div className="color_container visual_filter_color_container">
                  {colorGroups?.length > 0 &&
                    colorGroups.map(el => {
                      const { name = '', values = [] } = el;

                      return (
                        <div className="color_item">
                          <p className={`${luxe ? 'luxe' : ''} ${isFleek ? 'ajiogram' : ''}`}>
                            {name}
                          </p>
                          <div>
                            {values.map((eItem, index) =>
                              getFilterImprovedmentGenderFilter([`${code}-${eItem.code}`], index)
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              );
            };

            // NOTE: FOR FILTER IMPROVEMENT (SIZE)
            const isFilterImprovementEnabledAndIsSizeFilter =
              isFilterImprovementPhase2Enabled && parentEntityId === 'verticalsizegroupformat';
            const renderFilterImprovementSize = () => {
              const { l1Group = [] } = parentEntity || {};
              const hasMultipleL1Group = l1Group.length > 1;

              return (
                <div className="size_container">
                  {l1Group?.length > 0 &&
                    l1Group.map(el => {
                      const { name = '', l2Group = [] } = el;
                      const totalSizeCount = l2Group.reduce((acc, cur) => {
                        const totalCurSizeCount = cur.values.reduce((acc, cur) => {
                          acc += cur.count || 0;

                          return acc;
                        }, 0);

                        acc += totalCurSizeCount || 0;

                        return acc;
                      }, 0);

                      return (
                        <div className="size_item-group">
                          {hasMultipleL1Group && (
                            <p className={`${luxe ? 'luxe' : ''} ${isFleek ? 'ajiogram' : ''}`}>
                              {name}
                              <span>({totalSizeCount})</span>
                            </p>
                          )}
                          <div>
                            {l2Group.map((item, index) => {
                              const { name: l2GroupName = '', values = [] } = item;

                              return (
                                <div className="size_item">
                                  <p
                                    className={`${luxe ? 'luxe' : ''} ${isFleek ? 'ajiogram' : ''}`}
                                  >
                                    {l2GroupName}
                                  </p>
                                  {values.map((eItem, index) =>
                                    getFilterImprovedmentGenderFilter(
                                      [`${code}-${eItem.code}`],
                                      index
                                    )
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                </div>
              );
            };

            return (
              <div
                className={luxeColorFilter && 'luxeColorFilter'}
              >
                {searchComponent}
                {/* {code !== 'pricerange' || (code === 'pricerange' && !hasPriceFacet) ? ( */}
                <>
                  {isPDPhase2AndDeliveryFilterSelected && (
                    <AddressBarWrapper
                      handleDisplayDeliveryFilters={flag => this.handleDisplayDeliveryFilters(flag)}
                      clearSLAFacetSelection={this.clearSLAFacetSelection}
                      parentPage="filter"
                      clickedFilterTabCode={clickedFilterTabCode}
                      plpOnLandingCuratedId={plpOnLandingCuratedId}
                      isPlpOnLandingEnabled={isPlpOnLandingEnabled}
                      isFilterTabsOnLandingEnabled={isFilterTabsOnLandingEnabled}
                      {...this.props}
                    />
                  )}
                  {isPDPhase2AndDeliveryFilterSelected && !displayDeliveryFilters ? (
                    <div className="no-location-delivery-filter-container">
                      <div
                        className="no-location-delivery-filter-description"
                        style={isFleek ? { color: '#FFF' } : {}}
                      >
                        Please enter your location to see the delivery options
                      </div>
                    </div>
                  ) : (
                    <>
                      {isPDPhase2AndDeliveryFilterSelected && !isPriorityDeliveryOffered && (
                        <div
                          className={
                            isFleek
                              ? 'fleek-priority-delivery-unavailable'
                              : 'priority-delivery-unavailable'
                          }
                        >
                          Unfortunately, faster delivery is not offered in your location
                        </div>
                      )}

                      {/* NOTE: FOR FILTER IMPROVEMENT */}
                      {isFilterImprovementEnabledAndIsGenderFilter &&
                        renderFilterImprovementGender()}
                      {isFilterImprovementEnabledAndIsColorFilter && renderFilterImprovementColor()}
                      {isFilterImprovementEnabledAndIsSizeFilter && renderFilterImprovementSize()}

                      {!isFilterImprovementEnabledAndIsGenderFilter &&
                        !isFilterImprovementEnabledAndIsColorFilter &&
                        !isFilterImprovementEnabledAndIsSizeFilter &&
                        listDistribution.map((eItem, iKey) => {
                          const isBrandList = code === 'brand';
                          const noMarginClass =
                            (isBrandList && iKey + 1 !== listDistribution.length) ||
                            (code === 'pricerange' && isFromPopup)
                              ? 'rilrtl-list-no-margin'
                              : '';
                          return (
                            <div role={isBrandList ? 'list' : undefined}>
                              <List
                                ignoreListBehavior={isBrandList}
                                numOfItems={eItem.length}
                                showSearch={config.showSearch}
                                luxe={luxe}
                                className={
                                  isFleek ? `fleek-category-modal ${noMarginClass}` : noMarginClass
                                }
                                listItemRenderer={listProps => {
                                  const { index } = listProps;
                                  const entityId = eItem[index];
                                  if (typeof entityId === 'object') {
                                    return (
                                      <div className={luxe && 'facet-brand-title'}>
                                        <div
                                          className={`facet-linkname ${
                                            luxe
                                              ? 'facet-directory-luxe-title'
                                              : 'facet-directory-title'
                                          }`}
                                          style={isFleek ? { color: '#FFF' } : {}}
                                          role="heading"
                                          aria-level={2}
                                        >
                                          <strong>{entityId.title}</strong>
                                        </div>
                                      </div>
                                    );
                                  }
                                  const entity = entities[`${entityId}`] || {};
                                  let isChecked = false;
                                  if (formValue) {
                                    isChecked = formValue.includes(entity.code);
                                  }
                                  return (
                                    <div role={isBrandList ? 'listitem' : undefined}>
                                      <label
                                        className="facet-linkname"
                                        htmlFor={entity.name}
                                        style={
                                          code === 'verticalcolorfamily'
                                            ? { marginBottom: '12px' }
                                            : {}
                                        }
                                      >
                                        {code === 'rating' ||
                                        isPDPhase2AndDeliveryFilterSelected ? (
                                          <div>
                                            <span
                                              className="rilrtl-list-item__end-detail"
                                              role="radio"
                                              aria-checked={isChecked}
                                              aria-labelledby={`facet-list-title-name-${(
                                                entity.name || ''
                                              )
                                                .trim()
                                                .replace(
                                                  /\s+/g,
                                                  ''
                                                )} facet-list-title-count-${commify(
                                                entity.count || ''
                                              )}`}
                                            >
                                              <input
                                                {...(!popupFilterFromBottom && { tabIndex: '-1' })}
                                                style={
                                                  !popupFilterFromBottom
                                                    ? { display: 'none' }
                                                    : undefined
                                                }
                                                {...getFormDefaultProps({
                                                  type: 'radio',
                                                  name: code,
                                                  value: entity.code
                                                })}
                                                id={entity.name}
                                                checked={isChecked}
                                                disabled={
                                                  isPDPhase2AndDeliveryFilterSelected &&
                                                  (!isPriorityDeliveryOffered || entity.count === 0)
                                                }
                                                aria-labelledby={`facet-list-title-name-${(
                                                  entity.name || ''
                                                )
                                                  .trim()
                                                  .replace(
                                                    /\s+/g,
                                                    ''
                                                  )} facet-list-title-count-${commify(
                                                  entity.count || ''
                                                )}`}
                                              />
                                              <Icon
                                                ariaHidden={true}
                                                icon={`${
                                                  isChecked
                                                    ? 'icon-Radio-Button-Selected'
                                                    : 'icon-Radio-Button'
                                                }`}
                                                styles={{
                                                  ...(isFleek
                                                    ? { color: '#EBFF00', fontSize: '2.2rem' }
                                                    : { fontSize: '2.2rem' }),
                                                  ...(isPDPhase2AndDeliveryFilterSelected &&
                                                    (!isPriorityDeliveryOffered ||
                                                      entity.count === 0) && { opacity: 0.5 })
                                                }}
                                              />
                                            </span>
                                          </div>
                                        ) : (
                                          <div>
                                            <span
                                              className="rilrtl-list-item__end-detail"
                                              role="checkbox"
                                              aria-checked={isChecked}
                                              aria-labelledby={`facet-list-title-name-${(
                                                entity.name || ''
                                              )
                                                .trim()
                                                .replace(
                                                  /\s+/g,
                                                  ''
                                                )} facet-list-title-count-${commify(
                                                entity.count || ''
                                              )}`}
                                            >
                                              <input
                                                {...(!popupFilterFromBottom && { tabIndex: '-1' })}
                                                style={
                                                  !popupFilterFromBottom
                                                    ? { display: 'none' }
                                                    : undefined
                                                }
                                                {...getFormDefaultProps({
                                                  type: 'checkbox',
                                                  name: code,
                                                  value: entity.code
                                                })}
                                                id={entity.name}
                                                checked={isChecked}
                                                onClick={this.getPriceRangeGA(
                                                  entity.code,
                                                  isChecked,
                                                  code
                                                )}
                                              />
                                              {luxe ? (
                                                <Icon
                                                  ariaHidden={true}
                                                  icon={`${
                                                    isChecked
                                                      ? 'luxe-Checkbox-Selected'
                                                      : 'luxe-Checkbox'
                                                  }`}
                                                  styles={
                                                    isChecked
                                                      ? { fontSize: '2.2rem', color: '#121212' }
                                                      : { fontSize: '2.2rem', opacity: 0.5 }
                                                  }
                                                />
                                              ) : (
                                                <Icon
                                                  ariaHidden={true}
                                                  icon={`${
                                                    isChecked
                                                      ? 'icon-Checkbox-Selected'
                                                      : 'icon-Check-box'
                                                  }`}
                                                  styles={
                                                    isFleek
                                                      ? { color: '#EBFF00', fontSize: '2.2rem' }
                                                      : { fontSize: '2.2rem' }
                                                  }
                                                />
                                              )}
                                            </span>
                                          </div>
                                        )}

                                        <span
                                          aria-hidden="true"
                                          className={`${
                                            luxe
                                              ? 'rilrtl-list-luxe-item__title'
                                              : 'rilrtl-list-item__title'
                                          } ${isChecked ? 'list-active' : ''}`}
                                          style={isFleek ? { paddingLeft: '8px' } : {}}
                                        >
                                          {code === 'verticalcolorfamily' ? (
                                            <i
                                              className={`${
                                                luxe ? 'facet-luxe-color' : 'facet-color'
                                              } facet-color-${entity.name}`}
                                              style={{
                                                backgroundColor:
                                                  hexCode(entity.name.toLowerCase()) || name,
                                                ...(isFleek
                                                  ? {
                                                      border: '1px solid #F0F4F7',
                                                      marginRight: '10px'
                                                    }
                                                  : {}),
                                                ...(entity.name === 'Multi'
                                                  ? {
                                                      background: `url(${`${imageBaseUrl}/static/img/multi_color_swatch.png`})`,
                                                      backgroundRepeat: 'no-repeat',
                                                      backgroundPosition: 'center'
                                                    }
                                                  : {})
                                              }}
                                            ></i>
                                          ) : null}
                                          {code === 'rating' ? (
                                            <span
                                              id={`facet-list-title-name-${(entity.name || '')
                                                .trim()
                                                .replace(/\s+/g, '')}`}
                                              className={
                                                luxeColorFilter
                                                  ? 'facet-list-color-title-name'
                                                  : 'facet-list-title-name'
                                              }
                                              style={isFleek ? { color: '#FFF !important' } : {}}
                                            >
                                              {returnNewDiv({ currentString: entity.name })}
                                            </span>
                                          ) : (
                                            <span
                                              id={`facet-list-title-name-${(entity.name || '')
                                                .trim()
                                                .replace(/\s+/g, '')}`}
                                              className={
                                                luxeColorFilter
                                                  ? 'facet-list-color-title-name'
                                                  : `facet-list-title-name ${
                                                      isFleek ? 'fleek-color-important' : ''
                                                    }`
                                              }
                                              style={
                                                isPDPhase2AndDeliveryFilterSelected &&
                                                (!isPriorityDeliveryOffered || entity.count === 0)
                                                  ? { opacity: 0.5 }
                                                  : {}
                                              }
                                              aria-label={entity.name
                                                .replace(/Rs\.?/g, 'Rupees')
                                                .replace(/(\d+)\s*-\s*(\d+)/, '$1 to $2')}
                                            >
                                              {`${entity.name}`}{' '}
                                            </span>
                                          )}
                                          {!(
                                            isPDPhase2AndDeliveryFilterSelected &&
                                            (!isPriorityDeliveryOffered ||
                                              entity.count === 0 ||
                                              enableRushDelivery)
                                          ) && (
                                            <span
                                              id={`facet-list-title-count-${commify(
                                                entity.count || ''
                                              )}`}
                                              className={`facet-list-title-count ${
                                                isFleek ? 'fleek-color-important' : ''
                                              }`}
                                              aria-label={`(${commify(entity.count || '')}) ${
                                                entity.count ? 'items' : ''
                                              } `}
                                            >
                                              {' '}
                                              {`(${commify(entity.count || '')})`}
                                            </span>
                                          )}
                                          {enableRushDelivery &&
                                            code === 'sla' &&
                                            entity.deliveryMethod === DELIVERY_METHOD.RUSH && (
                                              <img
                                                className="rush-delivery-icon"
                                                alt="Rush Delivery Icon"
                                                src={replaceWithJioCDN(
                                                  priorityDeliveryConfig?.RUSH_ICON
                                                )}
                                              />
                                            )}
                                        </span>
                                      </label>
                                    </div>
                                  );
                                }}
                                isFleek={isFleek}
                                oldFlow={oldFlow}
                                keepDefaultRole={true}
                              />
                            </div>
                          );
                        })}
                      {code === 'brand' &&
                        searchTerm !== '' &&
                        !Array.isArray(searchTerm) &&
                        this.state.isSROnly && (
                          <span
                            className="sr-only"
                            aria-live="assertive"
                            role="alert"
                            style={{ position: 'absolute', left: '-9999px' }}
                          >
                            {filteredChildrens.filter(item => typeof item === 'string').length >
                              0 &&
                              `${
                                filteredChildrens.filter(item => typeof item === 'string').length
                              } suggestions are available`}
                          </span>
                        )}
                      {code === 'rating' && (
                        <div className="includeUnratedContainer">
                          <div className="includeUnratedLabel">
                            <div>
                              <input
                                id="includeUnratedProducts-checkbox"
                                type="checkbox"
                                className="unratedCheckBox"
                                name="includeUnratedProducts"
                                defaultChecked={this.props.includeUnratedProducts}
                                onClick={this.props.updateIncludeUnrated}
                              />
                              <Icon
                                ariaHidden={true}
                                icon={`${
                                  this.props.includeUnratedProducts
                                    ? 'icon-Checkbox-Selected'
                                    : 'icon-Check-box'
                                }`}
                                styles={{ fontSize: '2.2rem' }}
                                onClick={this.props.updateIncludeUnrated}
                              />
                            </div>{' '}
                            <label
                              htmlFor="includeUnratedProducts-checkbox"
                              className="ratingCheckboxLabel"
                            >
                              Include unrated products
                            </label>
                          </div>
                        </div>
                      )}
                      {isPDPhase2AndDeliveryFilterSelected && !luxe && !isFleek && (
                        <div className="paidDeliveryLabelContainer">
                          <p
                            className="paidDeliveryLabel"
                            aria-label="Some delivery option might be paid"
                          >
                            * Some delivery option might be paid
                          </p>
                        </div>
                      )}
                    </>
                  )}
                </>
                {/* ) : null} */}
                {code === 'pricerange' ? (
                  <div
                    className={luxe ? 'input-price-luxe-filter' : 'input-price-filter'}
                    style={
                      code === 'pricerange' && isFromPopup
                        ? { marginBottom: '80px', width: '250px' }
                        : {}
                    }
                  >
                    <div className="price-label">
                      <span
                        htmlFor="min-price"
                        className="price-range"
                        style={isFleek ? { color: '#FFF' } : {}}
                        role="heading"
                        aria-level={2}
                      >
                        <strong>Price Range</strong>
                      </span>
                      <span
                        className={luxe ? 'luxe-clear-price-filter' : 'clear-price-filter'}
                        style={isFleek ? { color: '#EBFF00' } : {}}
                        onClick={e => {
                          let defaultValues = this.getFormDefaultValues();
                          const values = rightPaneFormValues || defaultValues;
                          values.price = [];
                          this.props.removeFacets('priceFacets');
                          this.props.setRightPaneFormValues(code, values);
                          const { searchTerm, ...rest } = values;
                          if (facetsQuery.price) {
                            this.props.fetchFacets({
                              facets: stringifyFacets(rest)
                            });
                          }
                          this.removeMaxClass('clear');
                          this.removeClass('clear');
                          e.stopPropagation();
                        }}
                        role="button"
                        tabIndex={0}
                      >
                        Clear
                      </span>
                    </div>

                    <div className="facet-min-price-filter">
                      <div
                        className={`transCursor ${
                          luxe ? 'filterLuxeRange' : 'filterRange'
                        } filterMin ${floatLabelMin ? 'floatingLabel' : ''}`}
                        style={isFleek ? { background: '#1B1F23' } : {}}
                      >
                        <input
                          type= 'text'
                          pattern="\d*"
                          name="minPrice"
                          placeholder={isFleek ? '' : "Min"}
                          style={isFleek ? { color: '#FFF', background: '#1B1F23'} : {}}
                          id="minPlp"
                          onFocus={() => {
                            // this.updateClass();
                            this.props.showHidePriceRangeModal(true);
                          }}
                          value={priceRangeSplits[0] || ''}
                          onBlur={e => this.removeClass(e)}
                          className={isFleek ? 'fleek-price-input' : ''}
                        />
                        <label htmlFor="minPrice" style={isFleek ? { color: '#FFF' } : {}} >Min</label>
                      </div>
                      {/* <span className="ic-price-separator" /> */}
                      {isFleek ? (
                        <div style={{ color: '#FFF', margin: '0 10px' }} aria-label='-' aria-hidden="true">-</div>
                      ) : luxe ? (
                        <div style={{ margin: '0 10px' }} aria-label='-' aria-hidden="true">-</div>
                      ) : (
                        <Icon icon="icon-Subtract" styles={isFleek ? { color: '#FFF', margin: '0 10px' } : {}} ariaLabel="-" ariaHidden={true}/>
                      )}
                      <div
                        className={`transCursor ${luxe ? 'filterLuxeRange' : 'filterRange'} ${
                          luxe ? 'luxeFilterMax' : 'filterMax'
                        }  ${floatLabelMax && 'floatingLabel'}`}
                        style={isFleek ? { background: '#1B1F23' } : {}}
                      >
                        <input
                          type="text"
                          pattern="\d*"
                          name="maxPrice"
                          placeholder={isFleek ? '' : "Max"}
                          style={isFleek ? { color: '#FFF', background: '#1B1F23'} : {}}
                          onFocus={() => {
                            this.props.showHidePriceRangeModal(true);
                            // this.updateMaxClass();
                          }}
                          value={priceRangeSplits[1] || ''}
                          onBlur={e => this.removeMaxClass(e)}
                          // onBlur={this.removeMaxClass}
                          className={isFleek ? 'fleek-price-input' : ''}
                        />
                        <label htmlFor="maxPrice" style={isFleek ? { color: '#FFF' } : {}}>Max</label>
                      </div>
                      {/* <Input
                        type="number"
                        pattern="\d*"
                        name="minPrice"
                        label="Min"
                        onFocus={() => {
                          this.props.showHidePriceRangeModal(true);
                        }}
                        value={priceRangeSplits[0] || ""}
                      />
                      <Icon icon="icon-Subtract" />
                      <Input
                        type="number"
                        pattern="\d*"
                        name="maxPrice"
                        label="Max"
                        onFocus={() => {
                          this.props.showHidePriceRangeModal(true);
                        }}
                        value={priceRangeSplits[1] || ""}
                      /> */}
                      {!luxe && (
                        <span className="price-total-count">
                          {priceFacets.totalResults != null && priceFacets.totalResults > 0
                            ? `(${priceFacets.totalResults})`
                            : null}
                        </span>
                      )}
                    </div>
                    {!luxe && (
                      <div className="input-price-filter-error-container">
                        {priceFacets.totalResults === 0 && priceRangeSplits.length ? (
                          <span>
                            There are no products available for this price range. Please clear price
                            range.
                          </span>
                        ) : null}
                      </div>
                    )}
                  </div>
                ) : null}
                <div className="rilrtl-toolbar-bottom-fixed-adjust rilrtl-toolbar-bottom-fixed-adjust--filter-by" />
              </div>
            );
          }}
        </Form>
      </div>
    );
  }
}
function siftFilterlist(filterArr) {
  const newArr = [];
  filterArr.map((fd, i) => {
    const filterVal = newArr.filter(nd => nd === fd);
    filterVal && filterVal.length > 0 ? null : newArr.push(fd);
  });
  return newArr ? newArr : filterArr;
}

function filterChildrenByName(searchString = '', childrens = '', entities) {
  if (!searchString) return childrens;
  if (!Array.isArray(searchString)) {
    searchString = searchString.toLowerCase();
  }
  return childrens.filter(entityId => {
    const entity = entities[entityId] || {};
    let { name = '' } = entity;
    name = name.toLowerCase();
    if (Array.isArray(searchString)) {
      return searchString.includes(name.charAt(0));
    }
    return name.startsWith(searchString);
  });
}

function mapStateToProps(state, ownProps) {
  const { facets = {}, flags, metaData, request = {} } = state;
  const { name } = metaData;
  const {
    currentFacets = {},
    nextFacets = {},
    priceFacets = {},
    isPriorityDeliveryOffered = false
  } = facets;
  const { groupResults = [], groupEntities = {}, entities = {} } = nextFacets;
  const { query: facetsQuery } = nextFacets;
  const plpOnLandingData = getPlpOnLandingData(state);
  const { curatedid: plpOnLandingCuratedId = '' } = plpOnLandingData || {};
  return {
    groupResults,
    groupEntities,
    entities,
    request,
    facetsQuery,
    priceFacets,
    currentStore: name,
    isPriorityDeliveryOffered,
    luxeFlags: getLuxeFlags(flags),
    priorityDeliveryConfig: getPriorityDeliveryConfig(state) || {},
    enablePriorityDeliveryPhase2: getPriorityDeliveryPhase2Flag(state?.flags) || false,
    priorityDeliverySLPTagsConfig: getPriorityDeliverySLPTagsConfig(state) || {},
    enableRushDelivery: getRushDeliveryFlag(state),
    isPlpOnLandingEnabled: getPlpOnLandingEnabled(state) || false,
    isFilterTabsOnLandingEnabled: getFilterTabsOnLandingEnabled(state) || false,
    plpOnLandingCuratedId
  };
}
function mapDispatchToProps(dispatch, ownProps) {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    },
    removeFacets: id => {
      dispatch(removeFacets(id));
    },
    fetchFecetsFromPincode: params =>
      dispatch(
        fetchProducts({
          request: params.request,
          isRequestOrginIsBrowser: true,
          isRequestFromPlpOnLanding: params.isRequestFromPlpOnLanding
        })
      )
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacetCheckboxModalContent));
